// Tab icons using project PNG assets from src/icons/
import chartIcon from '@/icons/icons8-chart-50.png';
import clipboardIcon from '@/icons/icons8-clipboard-50.png';
import timeIcon from '@/icons/icons8-time-50.png';
import reportsIcon from '@/icons/icons8-reports-50.png';
import settingsIcon from '@/icons/icons8-settings-50.png';
import errorIcon from '@/icons/icons8-error-50.png';
import carsIcon from '@/icons/icons8-cars-50.png';

export function MarketValueIcon({ className }: { className?: string }) {
  return <img src={chartIcon} alt="" className={className} />;
}

export function TitleCheckIcon({ className }: { className?: string }) {
  return <img src={clipboardIcon} alt="" className={className} />;
}

export function AuctionIcon({ className }: { className?: string }) {
  return <img src={timeIcon} alt="" className={className} />;
}

export function WarrantyIcon({ className }: { className?: string }) {
  return <img src={reportsIcon} alt="" className={className} />;
}

export function MaintenanceIcon({ className }: { className?: string }) {
  return <img src={settingsIcon} alt="" className={className} />;
}

export function RepairsIcon({ className }: { className?: string }) {
  return <img src={errorIcon} alt="" className={className} />;
}

export function SalesHistoryIcon({ className }: { className?: string }) {
  return <img src={carsIcon} alt="" className={className} />;
}
